var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.model).length !== 0)?_c('div',{staticClass:"wrapper"},[_c('item-form',{attrs:{"model":_vm.model,"invloedspercentages":_vm.invloedspercentages,"isEditing":true}})],1):_c('div',{staticClass:"midden"},[_c('div',{staticStyle:{"color":"#20a8d8","font-size":"large"}},[_vm._v("Even geduld a.u.b.")]),_vm._v(" "),_c('fadeloader',{staticClass:"spinner2",attrs:{"loading":_vm.loading,"size":_vm.size,"color":_vm.color}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba713da6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/licht/ShowIntegratie.vue
// module id = 583
// module chunks = 1